export default __webpack_public_path__ + "static/media/gallery30.25c55df9.webp";